export class DRSettings {
  k: number = 32;
  d: number = 400;
  base: number = 1;
  log: number = 10;
}